const decode = require('jwt-decode')
import compareAsc from 'date-fns/compareAsc'

export function decodeUser() {
  try {
    const token = localStorage.getItem('token') || null
    let user = {}

    if (token) {
      user = decode(token)
      return user
    } else {
      return null
    }
  } catch (err) {
    return null
  }
}

export default (to, from, next) => {
  if (localStorage.getItem('token')) {
    return next()
  }
  return next('/login')
}

export const meta = {
  progress: {
    func: [
      { call: 'color', modifier: 'temp', argument: '#64FFDA' },
      { call: 'fail', modifier: 'temp', argument: '#6e0000' },
      { call: 'location', modifier: 'temp', argument: 'top' },
      { call: 'transition', modifier: 'temp', argument: { speed: '1.5s', opacity: '0.6s', termination: 600 } }
    ]
  }
}

export function AdminGuard(to, from, next) {
  const user = decodeUser()
  if (!user) {
    return next('/login')
  }
  
  if (user.isAdmin) {
    return next()
  }
  //return next('/orders/pending')
  return next('/login')
}

export function EditorGuard(to, from, next) {
  const user = decodeUser()
  console.log(user);
  if (!user) {
    return next('/login')
  }
  
  if (user.isAdmin || user.editor == true || user.manager == true) {
    return next()
  }
  //return next('/dashboard')
  return next('/login')
}


export function ExpertGuard(to, from, next) {
  const user = decodeUser()
  if (!user) {
    return next('/login/expert/normal')
  }

  if (user.accountType == 'sonko' || user.accountType == 'vip_sonko') {
    return next(`/login/expert/normal`)
  }

  const subscription = localStorage.getItem('subscription');

  if (user && user.verified == false) {
    return next(`/verify/expert/${user._id}`)
  }

  if (subscription == 'noSubs') {
    return next('/packages')
  }

  // check subscription expiry
  const expiryDate = new Date(user.expiryDate);
  const today = new Date();
  const cm = compareAsc(today, expiryDate)
  if (cm == 1) {
    return next('/expiry');
  }

  if(user.active==false){
    return next('/inactive');
  }

  if (user && user.locationOne == null || user.locationOne == undefined) {
    return next(`/location/update/expert`);
  }

  if (user && user.expertise.length < 1) {
    return next(`/expertise/update/expert`);
  }
  return next()
}

export function BidGuard(to, from, next) {
  const user = decodeUser()
  if (!user) {
    return next('/login/expert/normal?id='+to.params.id)
  }

  if (user.accountType == 'sonko' || user.accountType == 'vip_sonko') {
    return next('/login/expert/normal')
  }

  return next()
}


export function SonkoGuard(to, from, next) {
  const user = decodeUser()

  if (!user) {
    return next('/login/sonko/normal')
  }

  if (user.accountType == 'expert' || user.accountType == 'vip_sonko') {
    return next(`/login/sonko/normal`)
  }

  if (user && user.verified == false) {
    return next(`/verify/sonko/${user._id}`)
  }

  if (user && user.locationOne == null || user.locationOne == undefined) {
    return next(`/location/update/sonko`);
  }

  if (user && user.expertise.length < 1) {
    return next(`/expertise/update/sonko`)
  }

  return next()
}

export function EngageExpertGuard(to, from, next) {
  const user = decodeUser()
  
  if (!user) {
    return next('/login/sonko/normal?id='+to.params.id)
  }

  if (user.accountType == 'expert') {
    return next(`/expert/profile?error=true`)
  }

  return next()
}

export function CheckExpertGuard(to, from, next) {
  const user = decodeUser()
  
  if (!user) {
    return next('/login/expert/normal')
  }

  if (user.accountType == 'sonko' || user.accountType == 'vip_sonko') {
    return next(`/login/expert/normal`)
  }

  return next()
}

export function CheckSonkoGuard(to, from, next) {
  const user = decodeUser()
  
  if (!user) {
    return next('/login/sonko/normal')
  }

  if (user.accountType == 'expert'  || user.accountType == 'vip_sonko') {
    return next(`/login/sonko/normal`)
  }

  return next()
}

export function CheckAuth(to, from, next) {
  const user = decodeUser()
  
  if (!user) {
    return next('/')
  }

  return next()
}

export function VIPSonkoGuard(to, from, next) {
  const user = decodeUser()
  if (!user) {
    return next('/login/vip_sonko/normal')
  }

  if (user.accountType == 'expert' || user.accountType == 'sonko') {
    return next(`/login/vip_sonko/normal`)
  }

  const subscription = localStorage.getItem('subscription');

  if (user && user.verified == false) {
    return next(`/verify/vip_sonko/${user._id}`)
  }

  if (subscription == 'noSubs') {
    return next('/vip_sonko/packages')
  }

  // check subscription expiry
  const expiryDate = new Date(user.expiryDate);
  const today = new Date();
  const cm = compareAsc(today, expiryDate)
  if (cm == 1) {
    return next('/vip_sonko/expiry');
  }

  if(user.active==false){
    return next('/vip_sonko/inactive');
  }

  if (user && user.locationOne == null || user.locationOne == undefined) {
    return next(`/location/update/vip_sonko`);
  }
  console.log(user);
  if (user && user.expertise.length < 1) {
    /*return next(`/expertise/update/vip_sonko`);*/
    return next(`/vip_sonko/expertise/update/vip_sonko`);
  }
  return next()
}

export function CheckVIPSonkoGuard(to, from, next) {
  const user = decodeUser()
  console.log(user);
  if (!user) {
    return next('/login/vip_sonko/normal')
  }

  if (user.accountType == 'expert'  || user.accountType == 'sonko') {
    return next(`/login/vip_sonko/normal`)
  }

  return next()
}

export function ManagerGuard(to, from, next) {
  const user = decodeUser()
  if (!user) {
    return next('/login')
  }
  
  if (user.isAdmin || user.manager == true) {
    return next()
  }
  //return next('/dashboard')
  return next('/login')
}